module.exports = "/fonts/gt-walsheim-bold.ttf";